import _ from 'lodash';

import deserializer from './deserializer';

const needsDeserialization = (method) => {
  return ['GET', 'PATCH', 'POST'].indexOf(method) !== -1;
};

export default {
  name: 'response',
  res: (payload) => {
    /*
     *   Note: The axios ajax response attaches the actual response data to
     *         `res.data`. JSON API Resources also passes back the response with
     *         a `data` attribute. This means we have `res.data.data`.
     */
    const { jsonApi, req } = payload;
    const { status } = payload.res;
    const res = payload.res.data;
    const { errors, meta, links, included } = payload.res.data;

    let data = null;

    if (status !== 204 && needsDeserialization(req.method)) {
      if (_.isArray(res.data)) {
        data = deserializer.collection(jsonApi, res.data, included);
      } else if (res.data) {
        data = deserializer.resource(jsonApi, res.data, included);
      }
      deserializer.cache.clear();
    }

    if (res.data && data) {
      const params = ['meta', 'links'];
      params.forEach((param) => {
        if (res.data[param]) {
          data[param] = res.data[param];
        }
      });
    }

    return { data, errors, meta, links };
  },
};
